module.exports = __webpack_public_path__ + "static/media/yellow-corner.ca761168.svg";